<div class="c-acc-panel c-acc-panel--read">
  <div class="c-acc-panel__item">
    <div class="c-acc-panel__label">
      @if (!isEU) {
        <span>{{ 'MY-ACCOUNT/MY-PRIVACY.shareDetailsView' | translate}}</span>
      } @else {
        <span>{{ 'MY-ACCOUNT/MY-PRIVACY.shareDetailsViewEMEA' | translate}}</span>
      }
    </div>
    <div class="c-acc-panel__value">
      @if (privacySettings.shareDetailsWithProviderOptIn) {
        <span>{{ 'MY-ACCOUNT/MY-PRIVACY.Yes' | translate}}</span>
      }
      @if (!privacySettings.shareDetailsWithProviderOptIn) {
        <span>{{ 'MY-ACCOUNT/MY-PRIVACY.No' | translate}}</span>
      }
    </div>
    <div class="c-acc-panel__btn">
      <a class="c-link-ui" (click)="edit()">{{ 'MY-ACCOUNT.Change' | translate}}</a>
    </div>
  </div>
</div>
